import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById("root");

// Browser snapshots are not React server renders: mount afresh rather than
// hydrating incompatible loading/effect state. Static HTML remains useful without JS.
if (rootElement.hasChildNodes() && !rootElement.hasAttribute('data-prerendered')) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <HelmetProvider>
        <App />
        <Toaster />
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
        <Toaster />
      </HelmetProvider>
    </React.StrictMode>
  );
}
